module.exports = __webpack_public_path__ + "static/media/capy_logo_en@2x.cbac2386.png";